import { render, staticRenderFns } from "./AdoptionScoringSettings.vue?vue&type=template&id=b05c04f0&scoped=true"
import script from "./AdoptionScoringSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./AdoptionScoringSettings.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AdoptionScoringSettings.vue?vue&type=style&index=0&id=b05c04f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b05c04f0",
  null
  
)

export default component.exports